import { api } from "@/lib/api/client";
import type { AuthResult, DeviceFields, Me, OtpChallenge, PasswordLoginResult, Portal, RegisterInput, Session } from "./types";

/** Typed wrappers for /auth endpoints. Public calls never send a bearer token. */
export const authApi = {
  register: (input: RegisterInput) => api.post<OtpChallenge>("/auth/register", input, { auth: false }),
  requestOtp: (identifier: string) => api.post<OtpChallenge>("/auth/otp/request", { identifier }, { auth: false }),
  verifyOtp: (input: { challengeId: string; code: string } & DeviceFields) =>
    api.post<AuthResult>("/auth/otp/verify", input, { auth: false }),
  login: (input: { identifier: string; password: string } & DeviceFields) =>
    api.post<PasswordLoginResult>("/auth/login", input, { auth: false }),
  forgotPassword: (identifier: string) => api.post<OtpChallenge>("/auth/password/forgot", { identifier }, { auth: false }),
  resetPassword: (input: { challengeId: string; code: string; newPassword: string }) =>
    api.post<null>("/auth/password/reset", input, { auth: false }),

  me: () => api.get<Me>("/auth/me"),
  logout: () => api.post<null>("/auth/logout"),
  logoutAll: () => api.post<{ revoked: number }>("/auth/logout-all"),
  switchPortal: (portal: Portal) => api.post<AuthResult>("/auth/portal", { portal }),
  changePassword: (input: { currentPassword?: string; newPassword: string }) =>
    api.post<{ otherSessionsRevoked: number }>("/auth/password/change", input),
  sessions: () => api.get<{ items: Session[] }>("/auth/sessions"),
  revokeSession: (sessionId: string) => api.delete<{ current: boolean }>(`/auth/sessions/${encodeURIComponent(sessionId)}`),
};
